const UseDebounce = (value: any, delay?: number): any => {
    let timeoutId: any
    return wrapper
    function wrapper (...args: any) {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      timeoutId = setTimeout(() => {
        timeoutId = null
        value(...args)
      }, delay)
    }
}

export default UseDebounce